<template>
  <!-- لیست کشویی تغییر وضعیت اسناد -->
  <div class="divFilter" v-bind:style="setLocationShow()">
    <!-- از شناسه تا شناسه -->
    <div class="row mb-2">
      <div class="col pr-1 d-flex align-items-center">
        <input 
          class="form-check-input" 
          type="radio" 
          name="radioFinalTemporary" 
          id="radioFinal" 
          v-model="FinalOrTemporaryDoc"
          value="1" 
          checked
        />
        <label class="form-check-label radioFinal" for="radioFinal"> از موقت به قطعی </label>
      </div>
      <div class="col pl-1 d-flex align-items-center">
        <input 
          class="form-check-input mr-1" 
          type="radio" 
          name="radioFinalTemporary" 
          id="radioTemporary" 
          v-model="FinalOrTemporaryDoc"
          value="0" 
        />
        <label class="form-check-label radioFinal" for="radioTemporary"> از قطعی به موقت </label>
      </div>
    </div>
    <div class="row">
      <!-- انتخاب از شناسه تا شناسه -->
      <div class="col-1 p-1 text-right d-flex align-items-end">
        <input 
          class="form-check-input" 
          type="radio" 
          name="radioNoLabel" 
          id="radioNId" 
          value="" 
          checked
          v-on:click="selectNIdORDocNum('NId')"
        />
      </div>
      <!-- از شناسه -->
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">از شناسه ...</label>
        <input
          id="txtNId"
          type="number"
          class="form-control form-control-sm"
          placeholder="از شناسه ..."
          v-model="NID1"
          v-bind:disabled="DisabelNId"
        />
      </div>
      <!-- تا شناسه -->
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">تا شناسه ...</label>
        <input
          type="number"
          class="form-control form-control-sm"
          placeholder="تا شناسه ..."
          v-model="NID2"
          v-bind:disabled="DisabelNId"
        />
      </div>
    </div>
    <!-- از شماره تا شماره -->
    <div class="row">
      <!-- انتخاب از شماره تا شماره -->
      <div class="col-1 p-1 text-right d-flex align-items-end">
        <input 
          class="form-check-input" 
          type="radio" 
          name="radioNoLabel" 
          id="radioDocNum" 
          value=""
          v-on:click="selectNIdORDocNum('DocNum')"
        />
      </div>
      <!-- از شماره -->
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">از شماره ...</label>
        <input
          id="txtDocNum"
          type="number"
          class="form-control form-control-sm"
          placeholder="از شماره ..."
          v-model="NdocNu1"
          v-bind:disabled="DisabelDocNum"
        />
      </div>
      <!-- تا شماره -->
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">تا شماره ...</label>
        <input       
          type="number"
          class="form-control form-control-sm"
          placeholder="تا شماره ..."
          v-model="NdocNu2"
          v-bind:disabled="DisabelDocNum"
        />
      </div>
    </div>
    <!-- دکمه تغییر وضعیت اسناد به قطعی -->
    <div class="row mt-1 justify-content-end">
      <div class="col-1 p-1"></div>
      <div class="col p-1"></div>
      <div class="col p-1">
        <a
          class="
            btn btn-info btn-sm btn-floating
            m-0
            d-flex
            justify-content-around
            align-items-center
          "
          style="height: 30px; padding: inherit;"
          title="تغییر وضعیت اسناد"
          v-on:click="changeStatusDoc"
        >
          <i class="fas fa-filter fa-1x-half text-white px-2"></i>
          تغییر وضعیت اسناد
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // FilterDateStart: "",
      // FilterDateEnd: "",
      FinalOrTemporaryDoc: 1,
      NID1: "",
      NID2: "",
      NdocNu1: "",
      NdocNu2: "",
      DisabelNId: false,
      DisabelDocNum: true,
      // FilterSearch: "",
    };
  },
  props: ["LocationShow"],
  methods: {
    setLocationShow() {
      return "top: " + parseInt(this.LocationShow.top + 37) + "px;";
    },

    // انتخاب شناسه یا شماره
    selectNIdORDocNum(selValue){
      if(selValue == 'NId'){
        this.DisabelNId = false;
        this.DisabelDocNum = true;
        this.NdocNu1 = "";
        this.NdocNu2 = "";
        setTimeout(() => {
          $("#txtNId").focus();
          $("#txtNId").select();
        }, 50);
      } else {
        this.DisabelDocNum = false;
        this.DisabelNId = true;
        this.NID1 = "";
        this.NID2 = "";
        setTimeout(() => {
          $("#txtDocNum").focus();
          $("#txtDocNum").select();
        }, 50);
      }
    },

    // فیلتر لیست اسناد بر اساس مقادیر کاربر
    async changeStatusDoc() {
      // آیا مقادیر درج شده است ؟
      if (
        (this.DisabelNId == false &&
        (this.NID1 != "" && this.NID1 != 0) &&
        (this.NID2 != "" && this.NID2 != 0))
        ||
        (this.DisabelDocNum == false && 
        (this.NdocNu1 != "" && this.NdocNu1 != 0) &&
        (this.NdocNu2 != "" && this.NdocNu2 != 0))
      ) {
        // آیا مقدار شروع از پایان کوچکتر هست ؟
        if (
          (this.DisabelNId == false && this.NID1 < this.NID2)
          ||
          (this.DisabelDocNum == false && this.NdocNu1 < this.NdocNu2)
        ){
          // ارسال اطلاعات سمت سرور
          let userData = await this.$store.getters.getUserData;
          let token = userData.token;
          let nuserCode = userData.NUserCode;
          let yearActive = await this.$store.getters.getYearActive;

          console.log(this.NID1);
          console.log(this.NID2);

          // تغییر وضعیت اسناد سمت سرور
          var ActionResult = await this.$store.dispatch("ChangeDocStatusToServer", {
            ChangeDocData: {
              Status: this.FinalOrTemporaryDoc,
              NUserCode: nuserCode,
              NYear: yearActive,
              NID1: parseInt((this.NID1 != '' ? this.NID1 : 0)),
              NID2: parseInt((this.NID2 != '' ? this.NID2 : 0)),
              NdocNu1: parseInt((this.NdocNu1 != '' ? this.NdocNu1 : 0)),
              NdocNu2: parseInt((this.NdocNu2 != '' ? this.NdocNu2 : 0)),
            },
            token: token,
          });
          // آیا اطلاعاتی مشاهده شده است ؟
          if (ActionResult == 'OK') {
            this.$emit("HideFilter", listResult);
          } else if(ActionResult == 'NoCount') {
            swal({
              title: "عدم مشاهده اطلاعات",
              text: "برای مقادیر درج شده اطلاعاتی مشاهده نشد !",
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
          } else {
            swal({
              title: "عدم اجرای دستور",
              text: ActionResult,
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
          }
        } else {
          // شروع از پایان بزرگتر است
          swal({
            title: "عدم ثبت مقادیر صحیح",
            text: (this.DisabelNId == false ? "شروع شناسه سند باید از پایان شناسه سند کوچک تر باشد !" : "شروع شماره سند باید از پایان شماره سند کوچک تر باشد !"),
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "متوجه شدم",
            },
          });
        }
      } else {
        // مقادیر درج نشده است
        swal({
          title: "عدم ثبت مقادیر",
          text: (this.DisabelNId == false ? "درج مقدار شروع و پایان شناسه سند الزامی است !" : "درج مقدار شروع و پایان شماره سند الزامی است !"),
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "متوجه شدم",
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.divFilter {
  position: absolute;
  left: 0px;
  width: 300px;
  background-color: #e6f2fd;
  min-height: 80px;
  z-index: 9999;
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}
.radioFinal {
  margin-right: 23px;
  font-size: 12px;
  font-weight: 400;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListDocInfo/Components/ChangeStatusDoc.vue